import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html, unsafeStatic } from "lit/static-html.js";
import EkoElement from "@/utilities/element";
import { getSafeTag, type Tag } from "@/utilities/html";
import style from "./paragraph.css?inline";
import "./paragraph-light-dom.css";

@customElement("eko-paragraph")
class Paragraph extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) alignment?: "auto" | "center" | "left" | "right"; // default is `auto`
  @property({ reflect: true }) as?: Tag; // default is `p`
  @property({ reflect: true }) size?: "inherit" | "xs" | "sm" | "md" | "lg" | "xl"; // default is `inherit`
  @property({ reflect: true }) theme?:
    | "inherit"
    | "default"
    | "danger"
    | "info"
    | "success"
    | "warning"
    | "weak"
    | "weaker"
    | "weakest"; // default is `inherit`
  @property({ reflect: true }) weight?: "inherit" | "bold" | "medium" | "normal" | "semibold"; // default is `inherit`

  render() {
    return html`<${unsafeStatic(this.tag)} class="eko-paragraph" part="root">
      <slot></slot>
    </${unsafeStatic(this.tag)}>`;
  }

  private get tag() {
    return getSafeTag(this.as, "p");
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-paragraph": Paragraph;
  }
}

export default Paragraph;
